module.exports = __webpack_public_path__ + "img/newCenter_banner.b6b6f117.png";